const basicCampaignDefaultsPath = (routePath = '') =>
  `campaign-defaults${routePath && '/'}${routePath}`;

export const getCampaignDefaults = () => basicCampaignDefaultsPath();
export const updateCampaignDefaults = () => basicCampaignDefaultsPath();
